import { render, staticRenderFns } from "./carouselPrimeVue.vue?vue&type=template&id=66647db0&scoped=true&"
import script from "./carouselPrimeVue.vue.ts?vue&type=script&lang=ts&"
export * from "./carouselPrimeVue.vue.ts?vue&type=script&lang=ts&"
import style0 from "./carouselPrimeVue.vue?vue&type=style&index=0&id=66647db0&prod&lang=scss&scoped=true&"
import style1 from "./carouselPrimeVue.vue?vue&type=style&index=1&id=66647db0&prod&lang=css&"
import style2 from "./carouselPrimeVue.vue?vue&type=style&index=2&id=66647db0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66647db0",
  null
  
)

export default component.exports